<template>
  <th :id="columnId" ref="sortableColumn" :aria-sort="currentSortOrder" role="columnheader" class="table__th--sortable">
    <button @click="handleClick">
      <span>{{ label }}</span>
      <span>
        <span aria-hidden="true" class="material-icons">arrow_upward</span>
        <span aria-hidden="true" class="material-icons">arrow_downward</span>
      </span>
    </button>
  </th>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'SortableColumnHeader',
  props: {
    label: { type: String, required: true },
    sortOrder: { type: String },
    sortValue: { type: String, required: true },
  },
  mixins: [stringUtils],
  data() {
    return {
      currentSortOrder: this.sortOrder,
    }
  },
  computed: {
    columnId() {
      return `${this.toKebabCase(this.label)}-columnheader`
    },
  },
  methods: {
    handleClick() {
      const sortableColumnHeaders = this.$parent.$el.querySelectorAll('th.table__th--sortable')
      const currentColumnHeader = this.$refs.sortableColumn
      for (let i = 0; i < sortableColumnHeaders.length; i++) {
        let item = sortableColumnHeaders[i]
        if (item.id == currentColumnHeader.id) {
          if (item.ariaSort == 'descending') {
            item.ariaSort = 'ascending'
            this.$emit('sortColumn', 'ascending', this.sortValue)
          } else {
            item.ariaSort = 'descending'
            this.$emit('sortColumn', 'descending', this.sortValue)
          }
        } else {
          item.ariaSort = null
        }
      }
    },
  },
}
</script>
